export default "__VITE_ASSET__BzGblsix__";